import React, { lazy } from 'react';
import { StarIcon } from 'lucide-react';
export function ThankYou() {
  const testimonials = [{
    mainQuote: "You guys are literally the only marketers I've ever given a 10/10 to... And we've worked with dozens of agencies over the years.",
    detailedQuote: 'We took a NEW offer from ZERO to $3m in cumulative revenue within the 7-8 months we were working on it...',
    author: 'Rian Doris',
    position: 'Consulting.com x Flow Research Collective',
    imageSrc: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oiaj5uFwDCbSWrBFJPCHby/Rian_Headshot.jpg',
    socialCount: '441K'
  }, {
    mainQuote: 'The leads that came to me were EXACTLY the leads I was looking for, and it was a game changer for our business.',
    detailedQuote: "I've spent tons of money and tons of time working with other teams... and at the end of the day, I wasn't getting the lead that actually matched the avatar that I was looking to sell to. But working with DJ and Maciej was completely different.",
    author: 'Ben Kelly',
    position: 'Acquisition Ace x Light House Capital Group',
    imageSrc: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1YxboSyP5rQL5MzLY2yrky/Ben_Headshot.jpg',
    socialCount: '550K'
  }, {
    mainQuote: 'Their understanding of psychographics, psychology, marketing, and offer architecture is nothing short of world class.',
    detailedQuote: "It's the kind of surgical, sniper-like precision you rarely encounter. If you're fortunate enough to work with them, take their insight and implement it yesterday.",
    author: 'David Reineke',
    position: 'Aeon Financial Group x Arcian Holdings Limited',
    imageSrc: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8Cm3MhTVCK6K4nqqfG6wHw/Mastermind_Photo.jpg',
    socialCount: '75.4K'
  }, {
    mainQuote: "They did what no marketing agency could do, and that's actually do what they said they were gonna do.",
    detailedQuote: 'We had a $20,000 day... a $40,000 day... the results speak for themselves.',
    author: 'Zack Jenson',
    position: 'Tax Wise Financial Services x Accounting Ace',
    imageSrc: 'https://uploadthingy.s3.us-west-1.amazonaws.com/95qayCPmQquSF1XEQaRxXD/Zack_Headshot.jpg'
  }];
  return <div className="min-h-screen bg-slate-50 text-slate-900" data-id="element-348">
      <div className="max-w-4xl mx-auto px-6 py-16" data-id="element-349">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-12" data-id="element-350">
          Step 1: Please Watch The Short Video Below To Confirm Your Call
        </h1>
        <div className="aspect-video w-full rounded-xl overflow-hidden shadow-lg mb-12" data-id="element-351">
          <div style={{
          position: 'relative',
          paddingTop: '56.25%'
        }} data-id="element-352">
            <iframe src="https://iframe.mediadelivery.net/embed/460652/92c7924d-4b8a-4392-9317-bca2dfdd7bc7?autoplay=true&loop=false&muted=false&preload=true&responsive=true" loading="lazy" style={{
            border: 0,
            position: 'absolute',
            top: 0,
            height: '100%',
            width: '100%'
          }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen={true} data-id="element-353"></iframe>
          </div>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-354">
          Step 2: Watch This To Learn How We're Generating 30 to 100+ Seller
          Leads Per Month With Meta Ads
        </h2>
        <div className="aspect-video w-full rounded-xl overflow-hidden shadow-lg mb-12" data-id="element-355">
          <div style={{
          position: 'relative',
          paddingTop: '56.25%'
        }} data-id="element-356">
            <iframe src="https://www.youtube.com/embed/9Dy0pKJXxQ0" loading="lazy" style={{
            border: 0,
            position: 'absolute',
            top: 0,
            height: '100%',
            width: '100%'
          }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen={true} data-id="element-357"></iframe>
          </div>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-358">
          Step 3: See Some Real Life Client Case Studies From Working With Us
        </h2>
        <div className="space-y-8" data-id="element-359">
          <div className="bg-[rgb(240,240,240)] rounded-xl p-8 shadow-xl" data-id="element-360">
            <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-361">
              <div className="flex-shrink-0" data-id="element-362">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7BKmi1Xnpu7i2nKiXrD5UU/1733863671888.jpg" alt="Andrew Duncan headshot" className="w-full md:w-[300px] h-[300px] rounded-lg object-cover object-top" data-id="element-363" />
              </div>
              <div className="flex-grow" data-id="element-364">
                <div className="flex mb-4" data-id="element-365">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 text-[#00c853] fill-[#00c853]" data-id="element-366" />)}
                </div>
                <div className="text-2xl font-bold text-[#00c853] mb-4" data-id="element-367">
                  "These guys are sharp, know what they're doing, and offer so
                  much more than what it looks like on the surface."
                </div>
                <div className="text-lg text-gray-600 italic mb-6" data-id="element-368">
                  "I was skeptical at first, because the investment wasn't small
                  given where my business was. I can say that he was true to his
                  word and guided me through the entire process."
                </div>
                <div data-id="element-369">
                  <div className="text-gray-900 font-semibold" data-id="element-370">
                    Andrew Duncan
                  </div>
                  <div className="text-gray-600" data-id="element-371">Founder, VerticeLabs</div>
                </div>
              </div>
            </div>
          </div>
          {testimonials.map((testimonial, index) => <div key={index} className="bg-[rgb(240,240,240)] rounded-xl p-8 shadow-xl" data-id="element-372">
              <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-373">
                <div className="flex-shrink-0" data-id="element-374">
                  <img src={testimonial.imageSrc} alt={`${testimonial.author} headshot`} className="w-full md:w-[300px] h-[300px] rounded-lg object-cover object-top" data-id="element-375" />
                </div>
                <div className="flex-grow" data-id="element-376">
                  <div className="flex mb-4" data-id="element-377">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 text-[#00c853] fill-[#00c853]" data-id="element-378" />)}
                  </div>
                  <div className="text-2xl font-bold text-[#00c853] mb-4" data-id="element-379">
                    "{testimonial.mainQuote}"
                  </div>
                  <div className="text-lg text-gray-600 italic mb-6" data-id="element-380">
                    "{testimonial.detailedQuote}"
                  </div>
                  <div data-id="element-381">
                    <div className="text-gray-900 font-semibold" data-id="element-382">
                      {testimonial.author}
                    </div>
                    <div className="text-gray-600" data-id="element-383">{testimonial.position}</div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}